import { Link, useLocation } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";
import { useState, useEffect, useRef } from "react";

function CheckLocationPerms() {
  const location = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by this browser.");
      return;
    }

    function handleSuccess(position) {
      const { latitude, longitude } = position.coords;
    }

    function handleError(error) {
      // setError(error.message);
      ref.current.showModal();
    }

    navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state === "granted") {
      } else {
        if (result.state === "prompt") {
          // showButtonToEnableMap();
        }
        if (result.state === "denied") {
          ref.current.showModal();
        }
      }

      // Don't do anything if the permission was denied.
    });
  }, [location]);
  return (
    <>
      {/* <button
         className="btn"
         onClick={document.getElementById("my_modal_3").showModal()}
       >
         open modal
       </button> */}
      <dialog id="my_modal_3" className="modal" ref={ref}>
        <div className="modal-box h-full">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
              ✕
            </button>
          </form>
            <ShieldAlert />
          <h3 className="py-4 text-2xl">Location Permission issue</h3>
          <h4>Location is required to log a visit</h4>

          <p className="text-l py-4">
            This is likely an issue with either your browser or device settings
          </p>
          <p className="py-4">
            Please use the instructions below for your device:
          </p>
          <div className="flex gap-2 flex-col">
            <Link
              className="btn"
              target="_blank"
              to="https://support.google.com/chrome/answer/142065?hl=en-GB&co=GENIE.Platform%3DDesktop&oco=1"
            >
              Chrome (windows, mac & Android)
            </Link>
            <Link
              className="btn"
              target="_blank"
              to="https://support.apple.com/en-gb/guide/personal-safety/ips9bf20ad2f/web"
            >
              Safari (iOS & mac)
            </Link>
            <Link
              className="btn"
              target="_blank"
              to="https://support.microsoft.com/en-gb/microsoft-edge/location-and-privacy-in-microsoft-edge-31b5d154-0b1b-90ef-e389-7c7d4ffe7b04"
            >
              Microsoft Edge
            </Link>
          </div>
        </div>
      </dialog>
    </>
  );
}
export default CheckLocationPerms;
